module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/history_list-938412061579ca192ea1d4e710f65c5a.png";